import styles from "./Input.module.scss";
import { FC, InputHTMLAttributes } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  placeholder: string;
  className?: string;
}

export const Input: FC<InputProps> = ({ placeholder, className, ...rest }) => {
  return (
    <input
      className={`${styles.input} ${className}`}
      placeholder={placeholder}
      {...rest}
    />
  );
};
